// Base configuration
const baseUrl = "https://api.trustpilot.com";
const headers = new Headers({
    "apikey": "X5gIJ7NLOW3NU9twBXRI17xLsJiuuLgU"
});

// Fetch options
const reviewsOptions = {
    method: "GET",
    headers,
    redirect: "follow"
};

const profileOptions = {
    method: "GET",
    headers,
    redirect: "follow"
};

// Global data holders
let profileData = {};
let reviewsData = [];
let productReviewsData = [];

// Get SKUs from ShopifyAnalytics
function getProductSkus() {
    if (window.ShopifyAnalytics?.meta?.product?.variants) {
        return window.ShopifyAnalytics.meta.product.variants
            .map(variant => variant.sku)
            .filter(sku => sku);
    }
    return null;
}

// Fetch profile and reviews data
async function fetchData() {
    try {
        // Always fetch profile data and company reviews first
        const [profileResponse, reviewsResponse] = await Promise.all([
            fetch(`${baseUrl}/v1/business-units/665f1752af0c9a02df0ea9a5`, profileOptions),
            fetch(`${baseUrl}/v1/business-units/665f1752af0c9a02df0ea9a5/reviews?stars=4,5`, reviewsOptions)
        ]);
        
        profileData = await profileResponse.json();
        const reviewsResult = await reviewsResponse.json();
        reviewsData = reviewsResult.reviews;

        // Try to fetch product reviews if we're on a product page
        const skus = getProductSkus();
        if (skus) {
            const skuString = skus.join(',');
            const productReviewsUrl = `${baseUrl}/v1/product-reviews/business-units/665f1752af0c9a02df0ea9a5/reviews?perPage=10&language=en&stars=5&apikey=${headers.get('apikey')}&sku=${skuString}`;
            
            const productReviewsResponse = await fetch(
                productReviewsUrl,
                {
                    method: "GET",
                    redirect: "follow"
                }
            );
            
            const productReviewsResult = await productReviewsResponse.json();
            
            if (productReviewsResult.productReviews && productReviewsResult.productReviews.length > 0) {
                productReviewsData = productReviewsResult.productReviews;
            }
        }
        
        initializeComponents();
    } catch (error) {
        initializeComponents(); // Still try to initialize with any data we have
    }
}

// Initialize all components
function initializeComponents() {
    updateBar();
    updateAbout();
    updateBlock();
    updateProductCarousel();
    updateBlockProfile();
}

// Utility function to calculate time ago
function timeAgo(date) {
    const now = new Date();
    const secondsPast = (now.getTime() - date.getTime()) / 1000;
    if (secondsPast < 60) {
        return `${Math.round(secondsPast)} seconds ago`;
    }
    if (secondsPast < 3600) {
        return `${Math.round(secondsPast / 60)} minutes ago`;
    }
    if (secondsPast < 86400) {
        return `${Math.round(secondsPast / 3600)} hours ago`;
    }
    if (secondsPast < 2592000) { // less than 30 days
        return `${Math.round(secondsPast / 86400)} days ago`;
    }
    if (secondsPast < 31536000) { // less than 1 year
        return `${Math.round(secondsPast / 2592000)} months ago`;
    }
    return `${Math.round(secondsPast / 31536000)} years ago`;
}

// Update Trustpilot Bar
function updateBar() {
    const bars = document.querySelectorAll(".fastrak_kecks-trustpilot-bar");
    if (!bars.length) return;

    bars.forEach(bar => {
        const theme = bar.dataset.theme || 'dark';
        const textColor = theme === 'dark' ? 'white' : 'black';
        const logoVariant = theme === 'dark' ? 'gr-wht_RGB.svg?v=1730161416' : 'gr-blk-RGB.svg?v=1729704154';
        const trustScore = profileData.score ? profileData.score.trustScore : 'N/A';
        const numberOfReviews = profileData.numberOfReviews ? profileData.numberOfReviews.total : '0';
        
        bar.innerHTML = `
            <div class="fastrak_kecks-bar-group">
                <div class="fastrak_kecks-logo-stars">
                    <img src="https://cdn.shopify.com/s/files/1/0003/2070/0469/files/Trustpilot_brandmark_${logoVariant}" alt="Trustpilot Logo" class="fastrak_kecks-trustpilot-logo">
                    <div class="fastrak_kecks-star-rating">
                        <img src="https://images-static.trustpilot.com/api/stars/${Math.round(profileData.score ? profileData.score.trustScore : 0)}/star.svg" alt="${trustScore} stars">
                    </div>
                </div>
                <div class="fastrak_kecks-scores">
                    <span class="fastrak_kecks-trustscore" style="color: ${textColor};">TrustScore ${trustScore}</span>
                    <span class="fastrak_kecks-review-count" style="color: ${textColor};">| ${numberOfReviews} reviews</span>
                </div>
            </div>
        `;
    });
}

// Update About Section
function updateAbout() {
    const aboutSection = document.getElementById("fastrak_kecks-about-section");
    if (!aboutSection) return;

    aboutSection.innerHTML = `
        <div class="fastrak_kecks-header">
            <span>WHAT OUR CUSTOMERS SAY ABOUT US</span>
            <div id="fastrak_kecks-about-stars">
                <img src="https://images-static.trustpilot.com/api/stars/${profileData.score ? profileData.score.stars : 0}/star.svg" alt="${profileData.displayName}">
                <span>${profileData.score ? profileData.score.trustScore : '...'}</span>
            </div>
            <a class="fastrak_kecks-view-all-reviews" href="https://www.trustpilot.com/review/${profileData.name ? profileData.name.identifying : ''}">View all reviews</a>
        </div>
        <div class="about-swiper-container">
            <div class="swiper about-swiper">
                <div class="swiper-wrapper" id="fastrak_kecks-review-cards-about"></div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    `;

    renderAboutReviews();
}

// Render Reviews for About Section
function renderAboutReviews() {
    const reviewCards = document.getElementById("fastrak_kecks-review-cards-about");
    if (!reviewCards) return;
    reviewCards.innerHTML = '';
    
    let visibleReviews = reviewsData.slice(0, 3);
    document.documentElement.style.setProperty('--visible-reviews', visibleReviews.length);
    
    visibleReviews.forEach(review => {
        const reviewCard = document.createElement("div");
        reviewCard.className = "swiper-slide";
        const reviewText = review.isProductReview ? review.content : review.text;
        let initials = `${review.consumer.displayName.split(' ')[0][0]}${review.consumer.displayName.split(' ').length > 1 ? review.consumer.displayName.split(' ')[1][0] : ''}`;
        
        reviewCard.innerHTML = `
            <div class="fastrak_kecks-slide-container">
                <div class="fastrak_kecks-review-card">
                    <div>
                        <div class="fastrak_kecks-rating-verification">
                            <div class="fastrak_kecks-rating">
                                <span>${review.stars.toFixed(1)}</span>
                                <div class="fastrak_kecks-stars">
                                    <img src="https://images-static.trustpilot.com/api/stars/5/star.svg" alt="star">
                                </div>
                            </div>
                            <div class="fastrak_kecks-verification">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"/></svg>
                                <span>Verified User</span>
                            </div>
                        </div>
                        <div class="fastrak_kecks-review-text">
                            <a href="https://www.trustpilot.com/reviews/${review.id}"><p>${reviewText}</p></a>
                        </div>
                    </div>
                    <div class="fastrak_kecks-reviewer-info" onclick="window.location.href='https://www.trustpilot.com/users/${review.consumer.id}'">
                        <div class="fastrak_kecks-initials">${initials}</div>
                        <span class="name">${review.consumer.displayName}</span>
                        <span class="time-ago">${timeAgo(new Date(review.createdAt))}</span>
                    </div>
                </div>
            </div>
        `;
        reviewCards.appendChild(reviewCard);
    });

    // Initialize Swiper
    if (typeof Swiper !== 'undefined') {
        new Swiper('.about-swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    loop: true,
                    centeredSlides: true,
                    autoplay: {
                        delay: 4000,
                    },
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    enabled: false,
                    loop: false,
                    centeredSlides: false
                }
            }
        });
    }
}

// Update Block Section
function updateBlock() {
    const block = document.getElementById("fastrak_kecks-block-tp");
    if (!block) return;

    block.innerHTML = '';
    let visibleReviews;
    if (window.innerWidth > 1280) {
        visibleReviews = reviewsData.slice(0, 2);
    } else if (window.innerWidth > 768) {
        visibleReviews = reviewsData.slice(0, 1);
    } else {
        visibleReviews = reviewsData.slice(0, 5); // More reviews for mobile carousel
    }
    
    visibleReviews.forEach(review => {
        const reviewElement = document.createElement("div");
        reviewElement.className = "swiper-slide";
        let profileImage = review.consumer.links.find(link => link.rel === 'profile-image') ? review.consumer.links.find(link => link.rel === 'profile-image').href : '';
        let initials = `${review.consumer.displayName.split(' ')[0][0].toUpperCase()}${review.consumer.displayName.split(' ').length > 1 ? review.consumer.displayName.split(' ')[1][0].toUpperCase() : ''}`;
        reviewElement.innerHTML = `
            <div class="fastrak_kecks-review">
                <div>
                    <div class="fastrak_kecks-stars">
                        <img src="https://images-static.trustpilot.com/api/stars/${Math.round(review.stars)}/star.svg" alt="${review.stars} stars" style="height: 24px;">
                        <span>${review.stars.toFixed(1)}</span>
                    </div>
                    <h3 onclick="window.location.href='https://www.trustpilot.com/reviews/${review.id}'" style="cursor: pointer;">${review.title || ''}</h3>
                    <p class="fastrak_kecks-review-text">${review.text}</p>
                </div>
                <div class="fastrak_kecks-review-author" onclick="window.location.href='https://www.trustpilot.com/users/${review.consumer.id}'">
                    ${profileImage ? `<img src="${profileImage}" alt="${review.consumer.displayName}" />` : `<div class="fastrak_kecks-initials">${initials}</div>`}
                    <p>${review.consumer.displayName}</p>
                </div>
            </div>
        `;
        
        block.appendChild(reviewElement);
    });

    // Initialize Swiper for all screen sizes with different configs
    if (typeof Swiper !== 'undefined') {
        const blockSwiper = new Swiper('.block-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            allowTouchMove: window.innerWidth < 768,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    centeredSlides: true,
                    autoplay: {
                        delay: 4000,
                    },
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    allowTouchMove: false,
                    centeredSlides: false,
                },
                1280: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    allowTouchMove: false,
                    centeredSlides: false,
                }
            }
        });
    }
}

function updateBlockProfile() {
    const profileBlock = document.getElementById("fastrak_kecks-profile-block");
    if (!profileBlock) return;
    profileBlock.innerHTML = `
        <img src="https://s3-eu-west-1.amazonaws.com/tpd/logos/665f1752af0c9a02df0ea9a5/0x0.png" alt="${profileData.displayName}">
        <div class="fastrak_kecks-profile-block-content">
            <h2 onclick="window.location.href='https://www.trustpilot.com/review/${profileData.name.identifying}'" style="cursor: pointer;">${profileData.displayName}</h2>
            <p>Reviews: ${profileData.numberOfReviews.total} • Excellent</p>
            <div class="fastrak_kecks-company-rating">
                <img src="https://images-static.trustpilot.com/api/stars/${profileData.score.stars}/star.svg" alt="${profileData.displayName}">
                <span>${profileData.score.trustScore}</span>
            </div>
            <img src="https://cdn.shopify.com/s/files/1/0003/2070/0469/files/Trustpilot_brandmark_gr-blk-RGB.svg?v=1729704154" alt="Trustpilot Logo" class="fastrak_kecks-trustpilot-logo">
        </div>
    `;
    const viewAllLink = document.getElementById("fastrak_kecks-view-all-link");
    if (viewAllLink) viewAllLink.href = `https://www.trustpilot.com/review/${profileData.name.identifying}`;
}

// Update Product Carousel
function updateProductCarousel() {
    const swiperContainer = document.getElementById("fastrak_kecks-pc");
    if (!swiperContainer) return;

    // Use product reviews if available, otherwise fall back to company reviews
    const reviewsToShow = productReviewsData.length > 0 ? productReviewsData : reviewsData;
    const isProductReviews = productReviewsData.length > 0;
    
    swiperContainer.innerHTML = `
        <div class="fastrak_kecks-header">
            <h2 class="heading title-sm">${isProductReviews ? 'PRODUCT REVIEWS' : 'REVIEWS'}</h2>
            <div class="indicators hidden lg:flex gap-2d5">
                <button class="button button--secondary fs-prev-b" type="button" is="previous-button" aria-controls="fastrak_kecks-review-cards-carousel" aria-label="Previous">
                    <span class="btn-fill" data-fill=""></span>
                    <span class="btn-text">
                        <svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path>
                        </svg>
                    </span>
                    <span class="btn-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>
                <button class="button button--secondary fs-next-b" type="button" is="next-button" aria-controls="fastrak_kecks-review-cards-carousel" aria-label="Next">
                    <span class="btn-fill" data-fill=""></span>
                    <span class="btn-text">
                        <svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path>
                        </svg>
                    </span>
                    <span class="btn-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>
            </div>
        </div>
        <div class="swiper">
            <div class="swiper-wrapper" id="fastrak_kecks-review-cards-carousel">
            </div>
        </div>
    `;

    const reviewCards = document.getElementById("fastrak_kecks-review-cards-carousel");
    if (!reviewCards) return;
    reviewCards.innerHTML = '';
    
    let visibleReviews = reviewsToShow.slice(0, 20);
    
    visibleReviews.forEach(review => {
        const reviewCard = document.createElement("div");
        reviewCard.className = "swiper-slide";
        const reviewText = isProductReviews ? review.content : review.text;
        let initials = `${review.consumer.displayName.split(' ')[0][0]}${review.consumer.displayName.split(' ').length > 1 ? review.consumer.displayName.split(' ')[1][0] : ''}`;
        
        reviewCard.innerHTML = `
            <div class="fastrak_kecks-inner-slide">
                <div>
                    <div class="fastrak_kecks-rating-verification">
                        <div class="fastrak_kecks-rating">
                            <div class="fastrak_kecks-carousel-stars">
                                <img src="https://images-static.trustpilot.com/api/stars/${Math.round(review.stars)}/star.svg" alt="${review.stars} stars">
                                <span>${review.stars.toFixed(1)}</span>
                            </div>
                        </div>
                        <div class="fastrak_kecks-verification">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"/></svg>
                            <span>Verified User</span>
                        </div>
                    </div>
                    <div class="fastrak_kecks-review-text">
                        <a href="https://www.trustpilot.com/reviews/${review.id}"><p>${reviewText}</p></a>
                    </div>
                </div>
                <div class="fastrak_kecks-reviewer-info" onclick="window.location.href='https://www.trustpilot.com/users/${review.consumer.id}'">
                    <div class="fastrak_kecks-initials">${initials}</div>
                    <span class="name">${review.consumer.displayName}</span>
                    <span class="time-ago">${timeAgo(new Date(review.createdAt))}</span>
                </div>
            </div>
        `;
        reviewCards.appendChild(reviewCard);
    });

    // Initialize Swiper after slides are added
    if (typeof Swiper !== 'undefined') {
        new Swiper('.swiper', {
            loop: true,
            autoplay: {
                delay: 4000,
            },
            slidesPerView: 4,
            spaceBetween: 0,
            navigation: {
                nextEl: '.fs-next-b',
                prevEl: '.fs-prev-b',
            },
            cssMode: true,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
                1600: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
            },
        });
    }
}

// Initialize data fetch on page load
document.addEventListener('DOMContentLoaded', fetchData);